/** The installation standards a project can be checked against, with their names per language. */
import type { Locale } from './locale.ts';
import type { Standard } from './types.ts';

export const STANDARDS: ReadonlyArray<{
  value: Standard;
  /** Short name, as in "RGIE check" (Dutch says AREI). */
  short: Record<Locale, string>;
  /** Name with the country, for the project settings. */
  label: Record<Locale, string>;
}> = [
  {
    value: 'rgie',
    short: { fr: 'RGIE', en: 'RGIE', nl: 'AREI', de: 'AREI' },
    label: { fr: 'RGIE (Belgique)', en: 'RGIE/AREI (Belgium)', nl: 'AREI (België)', de: 'AREI (Belgien)' },
  },
  {
    value: 'nfc15100',
    short: { fr: 'NF C 15-100', en: 'NF C 15-100', nl: 'NF C 15-100', de: 'NF C 15-100' },
    label: {
      fr: 'NF C 15-100 (France)',
      en: 'NF C 15-100 (France)',
      nl: 'NF C 15-100 (Frankrijk)',
      de: 'NF C 15-100 (Frankreich)',
    },
  },
  {
    value: 'nen1010',
    short: { fr: 'NEN 1010', en: 'NEN 1010', nl: 'NEN 1010', de: 'NEN 1010' },
    label: {
      fr: 'NEN 1010 (Pays-Bas)',
      en: 'NEN 1010 (Netherlands)',
      nl: 'NEN 1010 (Nederland)',
      de: 'NEN 1010 (Niederlande)',
    },
  },
];

/** Short name of a project's standard: standardName('rgie', 'nl') → 'AREI'. */
export const standardName = (s: Standard | undefined, l: Locale): string =>
  (STANDARDS.find((x) => x.value === s) ?? STANDARDS[0]!).short[l];
